import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LegalNoticePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-zinc-500 hover:text-orange-400 text-sm mb-6 transition-colors"
          data-testid="legal-back"
        >
          <ChevronLeft size={18} /> Retour
        </button>

        <h1 className="text-2xl font-bold text-white mb-2" data-testid="legal-title">
          Mentions légales
        </h1>
        <p className="text-zinc-500 text-sm mb-8">Dernière mise à jour : mars 2026</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">1. Éditeur de l'application</h2>
            <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4 space-y-2 text-zinc-400">
              <p><strong className="text-zinc-300">Application :</strong> Suivi BTP</p>
              <p><strong className="text-zinc-300">Responsable de la publication :</strong> Frédéric GROSSET</p>
              <p><strong className="text-zinc-300">Société :</strong> AVIS DOM PLUS Conseil</p>
              <p><strong className="text-zinc-300">SIRET :</strong> 837 514 884 00027</p>
              <p>
                <strong className="text-zinc-300">Email :</strong>{" "}
                <a href="mailto:support@avidomplus.com" className="text-orange-400 hover:text-orange-300 transition-colors">
                  support@avidomplus.com
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">2. Nom de domaine</h2>
            <p className="text-zinc-400">
              Le nom de domaine de l'application est enregistré auprès de <strong className="text-zinc-300">Hostinger</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">3. Hébergement</h2>
            <p className="text-zinc-400">
              L'application Suivi BTP est hébergée sur une infrastructure cloud sécurisée
              fournie par la plateforme <strong className="text-zinc-300">Emergent</strong>.
              Les données sont stockées de manière sécurisée et conforme aux normes en vigueur.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">4. Responsabilité</h2>
            <p className="text-zinc-400">
              L'utilisation de l'application Suivi BTP se fait sous la responsabilité de
              l'utilisateur. AVIS DOM PLUS Conseil met tout en œuvre pour assurer la
              disponibilité et la fiabilité de l'application, mais ne saurait être tenue
              responsable des dommages directs ou indirects résultant de l'utilisation
              ou de l'impossibilité d'utiliser l'application.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">5. Propriété intellectuelle</h2>
            <p className="text-zinc-400">
              L'ensemble de l'application Suivi BTP, incluant sa structure, son design,
              ses fonctionnalités et ses contenus, est protégé par le droit de la propriété
              intellectuelle. Toute reproduction, représentation ou diffusion, totale ou
              partielle, sans autorisation expresse est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">6. Protection des données</h2>
            <p className="text-zinc-400">
              Pour toute information relative à la collecte et au traitement de vos données
              personnelles, veuillez consulter notre{" "}
              <a href="/privacy" className="text-orange-400 hover:text-orange-300 transition-colors">
                Politique de confidentialité
              </a>.
            </p>
          </section>
        </div>

        <div className="border-t border-zinc-800 mt-10 pt-6 text-center text-zinc-600 text-xs">
          Suivi BTP — by AVIS DOM PLUS Conseil
        </div>
      </div>
    </div>
  );
};

export default LegalNoticePage;
